import { useForm, Controller } from "react-hook-form";
import React, { useContext, useState } from "react";
import {
  CREATE_NEW_DOMAIN,
  type CreateNewDomainData,
  type DomainVariables,
} from "../CustomerProvisioningApi";
import { showToast } from "../../Forms/Dialogs/Toast/Toast";
import {
  TextButton,
  TextInput,
  useMutationWrapper,
  ModalContext,
  ModalButtonsContainer,
  showErrorDialog,
  REQUIRED_ERROR_MESSAGE,
} from "@SeemplicityDev/shared";

interface AddDomainProps {
  organizationSlug: string;
}

interface AddDomainFormData {
  domain: string;
}

const AddDomain: React.FC<AddDomainProps> = ({ organizationSlug }) => {
  const methods = useForm<AddDomainFormData>({ mode: "all" });
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = methods;
  const [createNewDomain] = useMutationWrapper<
    CreateNewDomainData,
    DomainVariables
  >(CREATE_NEW_DOMAIN, {
    refetchQueries: ["cnc_organizations"],
  });
  const { closeModal } = useContext(ModalContext);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);

  const onSubmit = (data: AddDomainFormData) => {
    setIsSubmittingForm(true);
    createNewDomain({
      variables: {
        organization_slug: organizationSlug,
        domain: data.domain,
      },
    })
      .then((res) => {
        setIsSubmittingForm(false);
        closeModal();
        showToast({
          message: res.data?.cnc_add_domain?.msg,
        });
      })
      .catch((err: { message?: string }) => {
        setIsSubmittingForm(false);
        showErrorDialog({ message: err.message });
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name={"domain"}
        render={({ field: { value, onChange, onBlur } }) => {
          return (
            <TextInput
              type={"text"}
              placeholder={"Type the domain URL"}
              value={value}
              data-testid={"new-domain"}
              labelTop
              onBlur={onBlur}
              name={"domain"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                onChange(e);
              }}
              label={"New Domain"}
              error={errors.domain ? errors.domain : null}
            />
          );
        }}
        control={control}
        rules={{
          required: REQUIRED_ERROR_MESSAGE,
        }}
      />
      <ModalButtonsContainer>
        <TextButton
          type="button"
          data-testid={"add-domain-cancel"}
          label={"Cancel"}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            closeModal();
          }}
        />
        <TextButton
          type="submit"
          label={"Save"}
          data-testid={"add-domain"}
          buttonStyle={"primary"}
          rightIcon={isSubmittingForm ? "seem-icon-spinner spinner" : ""}
          isSubmitting={isSubmittingForm}
          disabled={!isValid || !isDirty || isSubmittingForm}
        />
      </ModalButtonsContainer>
    </form>
  );
};
export default AddDomain;
